/**
 * 创建人：但志强
 * 时间：2019-3-29
 * 描述：在提示框使用的图标库
 * 使用说明: 参考 sw-icon 配置应用说明文档
 * 更新记录: 
 */
import { Component, Input} from '@angular/core';
@Component({
  selector: 'sw-icon',
  templateUrl: './sw-icon.component.html',
})
export class SwIconComponent {
  @Input() type: string;
}
